import { useState } from "react";
import { useField } from "formik";
import Checkbox from "@mui/material/Checkbox";
import FormAlert from "../Alert/FormAlert";
import FormControlLabel from "@mui/material/FormControlLabel";

const CheckboxInput = ({ children, ...props }) => {
  // useField with type 'checkbox' returns { checked, name, onChange, onBlur }
  const [field, meta] = useField({ ...props, type: "checkbox" });
  const [showError, setShowError] = useState(true);

  return (
    <>
      <FormControlLabel
        control={<Checkbox {...field} {...props} />}
        label={children}
      />

      {meta.touched && meta.error && showError && (
        <FormAlert
          severity="warning"
          message={meta.error}
          onClose={() => setShowError(false)}
        />
      )}
    </>
  );
};

export default CheckboxInput;
